<template>
  <div>
    <div>
      <div class="inbox-search-wrap">
        <div class="input-group">
          <div class="input-group-prepend search-prepend mobile-responsive">
            <i class="fas fa-search" />
          </div>
          <input
            id="txtFastStudentSearchSie"
            v-model="sieId"
            type="text"
            class="form-control"
            placeholder="Entrar Número de SIE o Registro"
            @keypress="onKeyPressed($event)"
          />
          <div id="button-addon4" class="input-group-append mobile-responsive">
            <button
              id="btnFastStudentSearch"
              class="btn-success-softer search-action-button button-border-right"
              type="button"
              @click="search()"
            >
              <span>Buscar</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <Error v-if="errorMessage" :message="errorMessage" class="m-3" />
    <ResultList
      v-if="canShowList"
      :student-list="studentList"
      @select-student="selectStudent"
      @showStudentInfo="showStudentInfo"
    />
    <History
      v-if="!canShowList && !selectedStudent"
      @select-student="checkAndSelectStudent"
    />
  </div>
</template>

<script>
// services
import studentService from '@/services/student';
import store from '@/store/index';
import loading from '@/mixin/loading.mixin';

// Components
import ResultList from './ResultList';
import History from './History';
import resourcesService from '@/services/resources.js';
import Error from '@/components/common/Error';
import StudentStatuses from '@/utils/constants/student/studentStatuses';
import { trackingNavMenu as _trackingNavMenu } from '@/modules/user/api';
import { getCurrentAcademicYear } from '@/services/api/tapRequest.api.js';
export default {
  components: {
    ResultList,
    History,
    Error,
  },
  mixins: [loading],
  data() {
    return {
      studentList: [],
      selectedStudent: null,
      sieId: '',
      errorMessage: '',
      resources: [],
      academicYearId: null,
    };
  },
  created() {
    this.loadResources();
  },
  computed: {
    canShowList() {
      return this.studentList.length > 0 && !this.selectedStudent;
    },
    viewCard() {
      return store.state.navigateToViewCard;
    },
  },
  methods: {
    showStudentInfo(student) {
      this.$emit('showStudentInfo', student);
    },
    onKeyPressed(event) {
      if (event.keyCode === 13) {
        this.search();
      }
      let pressedNumber = event.keyCode > 47 && event.keyCode < 58;

      if (!pressedNumber) return event.preventDefault();
    },
    async search() {
      this.studentList = [];
      this.errorMessage = '';

      if (this.sieId.length === 0) {
        this.errorMessage = this.resources['21056'];
        return;
      }

      try {
        let webServiceSearchOnly = store.getters.WebServiceStudentSearchEnabled;

        let { data: response } = await studentService.getBySie(
          this.sieId.trim(),
          webServiceSearchOnly
        );
        this.studentList = [response];
      } catch ({ response: error }) {
        this.errorMessage = error.data.message;
      }
    },
    setLoading(isLoading) {
      this.$emit('on-loading', isLoading);
    },
    async getCurrentAcademicYear() {
      let { data } = await getCurrentAcademicYear();
      return data.id;
    },
    async checkAndSelectStudent(student) {
      try {
        this.errorMessage = '';
        let webServiceSearchOnly = store.getters.WebServiceStudentSearchEnabled;

        let { data: response } = await studentService.getBySie(
          student.studentId,
          webServiceSearchOnly
        );

        await this.selectStudent(response);
      } catch ({ response: error }) {
        this.errorMessage = error.data.message;
      }
    },
    async selectStudent(student) {
      if (student) {
        let canAccess = student.canAccess;

        if (!canAccess) {
          this.errorMessage = this.resources['44'];
          return;
        }
        //Valid if Student can be selected
        const isRegistrationModule =
          store.state.navigateToViewRoute == '/student/registryhistory';

        const mipeStudent =
          !student.existsLocally ||
          (student.existsLocally &&
            student.statusId == StudentStatuses.Disponible);

        if (!isRegistrationModule && mipeStudent) {
          canAccess = false;
        }
        if (!canAccess) {
          this.errorMessage = this.resources['22041'];
          return;
        }

        if (canAccess) {
          this.academicYearId = await this.getCurrentAcademicYear();
          let webServiceSearchOnly =
            store.getters.WebServiceStudentSearchEnabled;
          this.selectedStudent = student;
          const payload = {
            navMenuId: isNaN(this.viewCard) ? 0 : Number(this.viewCard),
            academicYearId: this.academicYearId,
            studentSieId: isNaN(student.studentId)
              ? null
              : Number(student.studentId),
          };
          await _trackingNavMenu(payload);
          await store.dispatch('$_student/setStudentDetails', {
            studentId: student.studentId,
            autoCreateStudentData: webServiceSearchOnly,
            student,
            selectThisStudent: true,
          });
          store.commit('$_student/showStudentBox', true);
          this.$emit('toggleStudentSearchBox');
        }
      }
    },
    async loadResources() {
      //TODO: Always called :S
      this.resources = await resourcesService.LoadValidationMessages([
        '44',
        '21056',
        '22041',
      ]);
    },
  },
};
</script>
